<template>
	<div>
		<searchForm ref="MyTerm" @show="show" @handleSubmit="handleSubmit"></searchForm>
		<Table :columns="columns1" :data="data" :height="tableHeight"></Table>
		<MyPage ref="sonPage" :param="SelectParam" :url="getBsPackagesUrl" @listData='getDeviceData'></MyPage>
		<infoModal @handleSubmit="handleSubmit" ref="ItemModal"></infoModal>
	
	<Modal :z-index="zindex" :mask-closable="false" v-model="showMap" :title="modal.Title" @on-ok="closeMap(true)"
			@on-cancel="closeMap(false)" width="70%">
		
			<div class="map-input">
				<!-- <Input class="lnglat" v-model="mapLng" disabled placeholder="经度" />
				<Input class="lnglat" v-model="mapLat" disabled placeholder="纬度" /> -->
				<!-- <Input class="search" search enter-button="查找" v-model="inputCity" @on-search="searchCity"
					placeholder="输入选择城市" /> -->
			</div>
			<div id="map" style="width: 100%;height: 500px;margin-top: 5px;">
			</div>
			
			
	</Modal>

	
  
	</div>

	
</template>
<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import searchForm from './Template/BatteryInfoForm.vue';
	import infoModal from './Template/BatteryInfoModal.vue';
	
	import webapi from '../../../webapi';
	import MapObj from '@/js/TMap.js';
	// import DistributeModal from './Template/DistributeModal.vue';
	export default {
		components: {
			searchForm,
			infoModal
		},
		data() {
			return {
				getBsPackagesUrl: webapi.base_api_url + '/Operations/GetBatteryBaseInfos',

				mapInst: null,
				mapLng: 0,
				mapLat: 0,
				zindex: 2000,
				modal: {
					Title: "轨迹",
					type: "location"
				},
						//地图modal
				center: [114.198595, 22.633595],
				showMap: false,
				inputCity: '深圳',

				//Query Component Parameters
				SelectParam: {},
				loadingStatus: false,
				tableHeight: "650",
				BreadcrumbList: ['运营管理', '>>', '电池列表'],
				//Table Title Data
				columns1: [
					// {
					// 	title: 'ID',
					// 	key: 'Id',
					// 	width: 100
					// }, 
					{
						title: '设备编码',
						key: 'EquipNo',
						width: 160
					},
					{
						title: '场站',
						key: 'StationName',
						width: 180
					},
					{
						title: '电池状态',
						key: 'BatteryWorkStatusDesc',
					},

					{
						title: '总电压V',
						key: 'TotalVoltage',

					}, 
					{
						title: '总电流A',
						key: 'TotalCurrent',

					}, 
					{
						title: 'SOC%',
						key: 'SOC',

					}, 
					{
						title: 'SOH%',
						key: 'SOH',

					}, 
				
					{
						title: '压差mv',
						key: 'BalancedActivateVoltDiff',

					},
					
					{
						title: '循环次数',
						key: 'LoopNum',

					},
					{
						title: '警告级别',
						key: 'AlarmLevel',

					},
					{
						title: 'GSM信号',
						key: 'GsmRssi',

					},
					
					{
						title: '上报时间',
						key: 'ReportTime',
						minWidth: 150,

					},
					{
						title: this.$t('Common.Actions'),
						key: '',
						minWidth: 140,
						render: (h, params) => {
							let myButton = []
							console.log(params.row.OrderStatus);
							myButton.push(
									// h('Button', {
									// 	props: {
									// 		type: 'primary',
									// 		size: 'small'
									// 	},
									// 	style: {
									// 		marginRight: '5px'
									// 	},
									// 	on: {
									// 		click: () => {
									// 			this.show('location', params.row)
									// 		}
									// 	}
									// }, '查看位置'),
									h('Button', {
										props: {
											type: 'primary',
											size: 'small'
										},
										style: {
											marginRight: '5px'
										},
										on: {
											click: () => {
												this.show('detail', params.row)
											}
										}
									}, this.$t('Common.View'))
							)
							return h('div', myButton);
						}
						
					},
			
				
				],
				data: []
				
			}
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 220;
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.SelectParam = this.$refs.MyTerm.formInline
			this.$nextTick(() => {
				this.handleSubmit();
			})
		},
		computed: {
		
			...mapState({
				StationList: 'Stations',
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			

		  //地图modal
			mapOpen: function(Longitude,Latitude) {
				
				console.log("location:",Longitude,Latitude);
				const _this = this;
				this.showMap = true;
				let latlng = [Longitude, Latitude];
			
				this.mapLng = Longitude;
				this.mapLat = Latitude;

				this.$nextTick(() => {
					// gaodeMap.initMap("map", 9, this.center, 'normal');
					// gaodeMap.mapOn2(this);
					// gaodeMap.createMarke(latlng)
					// if (this.StationForm.Latitude != 0) {
					// 	gaodeMap.map.setCenter(latlng)
					// }
					_this.mapInst = new MapObj(window.TMap);
					_this.mapInst.initMap('map', 10, latlng[0], latlng[1]);
					const markerId = 1;
					_this.mapInst.createMarker(markerId, latlng[0], latlng[1]);
					// _this.mapInst.on('click', (evt) => {
					// 	_this.mapInst.setMarkerPosition(markerId, evt.latLng.lng, evt.latLng.lat);
					// 	this.mapLng = evt.latLng.lng;
					// 	this.mapLat = evt.latLng.lat;
					// })
				})

			},
			closeMap: function(result) {
				const _this = this;
				
				// gaodeMap.map.destroy();
				// gaodeMap.map = '';
				_this.mapInst.destroyMap();
				this.showMap = false;
			},
			searchCity: function() {
				const _this = this
				// _this.$axios.get('https://apis.map.qq.com/ws/geocoder/v1/?address=%E6%B7%B1%E5%9C%B3%E5%8C%97%E7%AB%99&key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77')
				this.mapInst.geoCoder(_this.inputCity).then(res => {
					_this.StationForm.Longitude = res.result.location.lng;
					_this.StationForm.Latitude = res.result.location.lat;
					_this.mapInst.setCenter(_this.StationForm.Longitude, _this.StationForm.Latitude);
					_this.mapInst.setMarkerPosition(1, _this.StationForm.Longitude, _this.StationForm.Latitude);
				});
				// gaodeMap.geoCode(_this.inputCity).then(res => {
				// 	_this.StationForm.Latitude = res.getLat()
				// 	_this.StationForm.Longitude = res.getLng()
				// 	gaodeMap.mapOn2(_this)
				// 	gaodeMap.createMarke(res)
				// 	gaodeMap.map.setCenter(res)
				// 	//console.log(res)
				// })
			},

			/**Component Fixing Method**/
			show: function(type, params) {
				switch (type) {
					case 'up':
						this.$refs.ItemModal.show(type, params)
						break;
					case 'detail':
						console.log("detail=",params.EquipNo);
						if(params.EquipNo !=null && params.EquipNo !=undefined){
                        this.$refs.ItemModal.show(type, params)
						}
						break;
						
					case 'Menu':
						this.$refs.MenuModal.show(type, params)
						break;
				   case 'location':
						this.mapOpen(params.Longitude,params.Latitude);
						//this.$refs.ItemModal.show(type, params)
						break;
					case 'detail':
						
					
						//this.$refs.ItemModal.show(type, params)
						break;
				}
			},
			getDeviceData: function(data) {
				console.log(data)
				this.data = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220;
			},
		},
	}
</script>

<style>
</style>
